module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-gray page-flex"
  }, [_c('appStatus', {
    attrs: {
      "statusHeight": _vm.statusHeight
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-input-title",
    style: ({
      top: _vm.statusHeight + 'rem'
    })
  }, [_c('div', {
    staticClass: "alifont icon-back left-icon click",
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pageInfo.keywords),
      expression: "pageInfo.keywords"
    }],
    staticClass: "center-input fs-28",
    attrs: {
      "type": "search",
      "placeholder": "搜索订单号/手机号"
    },
    domProps: {
      "value": (_vm.pageInfo.keywords)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        return _vm.handleQuery.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pageInfo, "keywords", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right fs-28 color-333 click",
    on: {
      "click": _vm.handleQuery
    }
  }, [_vm._v("\n                搜索\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "page-state"
  }, [_c('van-tabs', {
    attrs: {
      "swipeable": "",
      "swipe-threshold": 5,
      "line-width": '.6rem'
    },
    on: {
      "click": _vm.tabClick
    },
    model: {
      value: (_vm.tabActive),
      callback: function($$v) {
        _vm.tabActive = $$v
      },
      expression: "tabActive"
    }
  }, _vm._l((_vm.tabList), function(item, $index) {
    return _c('van-tab', {
      key: $index,
      attrs: {
        "title": item.title,
        "name": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "org-filter-bar bg-fff"
  }, [_c('div', {
    staticClass: "org-filter-trigger click",
    on: {
      "click": _vm.openOrgPicker
    }
  }, [_c('span', {
    staticClass: "org-filter-label"
  }, [_vm._v("小区")]), _vm._v(" "), _c('span', {
    staticClass: "org-filter-value ellipsis"
  }, [_vm._v(_vm._s(_vm.orgDisplayName))]), _vm._v(" "), _c('van-icon', {
    staticClass: "org-filter-icon",
    attrs: {
      "name": "arrow-down"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex1 posi-rel"
  }, [_c('scroller', {
    ref: "scroller",
    attrs: {
      "on-refresh": _vm.loadNewData,
      "on-infinite": _vm.loadMore
    }
  }, [_c('ul', {}, _vm._l((_vm.data), function(item, $index) {
    return _c('li', {
      key: $index,
      staticClass: "order-item",
      on: {
        "click": function($event) {
          _vm.getScrollerPosition();
          _vm.$router.push({
            name: 'orderDetail',
            query: {
              orderId: item.orderId,
              isManager: _vm.isManager
            }
          })
        }
      }
    }, [(item.orderStatus == 2) ? _c('div', {
      staticClass: "bd-bot"
    }, [_c('div', {
      staticClass: "flex-center address-box"
    }, [_c('div', {
      staticClass: "alifont icon-dizhi"
    }), _vm._v(" "), _c('div', {
      staticClass: "flex1"
    }, [_c('div', {
      staticClass: "fs-28 color-333"
    }, [_vm._v(_vm._s(item.userAddress))]), _vm._v(" "), _c('div', {
      staticClass: "flex fs-28 color-999 mt-5"
    }, [_c('div', {
      staticClass: "mr-30"
    }, [_vm._v(_vm._s(item.userName))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.userMobile))])])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (item.userName + ',' + item.userMobile + ',' + item.userAddress),
        expression: "item.userName +','+item.userMobile + ',' + item.userAddress",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.onCopySuccess),
        expression: "onCopySuccess",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: (_vm.onCopyError),
        expression: "onCopyError",
        arg: "error"
      }],
      staticClass: "text-center fs-32 color-main pb-25 click",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_vm._v("\n                                复制发货信息\n                            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "flex-between fs-28 bd-bot pd-250"
    }, [_c('div', {
      staticClass: "color-333"
    }, [_c('div', [_vm._v("订单编号：" + _vm._s(item.orderNo))]), _vm._v(" "), (item.orgName) ? _c('div', {
      staticClass: "color-999 fs-24 margin-top-sm"
    }, [_vm._v("小区：" + _vm._s(item.orgName))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "color-999 fs-24 margin-top-sm"
    }, [_vm._v(_vm._s(item.payTime))])]), _vm._v(" "), _vm._l((_vm.dicts['orderStatus']), function(dictItem) {
      return (String(item.orderStatus) == dictItem.code) ? _c('div', {
        key: dictItem.codeid
      }, [_c('span', {
        class: dictItem.code == 1 ? 'color-main' : (dictItem.code == 9 || dictItem.code == 0) ? 'color-red' : 'color-org'
      }, [_vm._v(_vm._s(dictItem.codename))])]) : _vm._e()
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "product-list bd-bot"
    }, _vm._l((item.productList), function(prod, prodIndex) {
      return _c('div', {
        key: prodIndex,
        staticClass: "product-item flex pd-250"
      }, [_c('div', {
        staticClass: "product-img"
      }, [_c('img', {
        attrs: {
          "src": prod.imgPathView,
          "alt": ""
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "product-info flex1 ofh"
      }, [_c('div', {
        staticClass: "fs-28 color-000 name"
      }, [_vm._v(_vm._s(prod.productName))]), _vm._v(" "), _c('div', {
        staticClass: "mt-15 fs-28 color-999"
      }, [_vm._v("规格：" + _vm._s(prod.specName))]), _vm._v(" "), _c('div', {
        staticClass: "flex-between fs-28 color-999"
      }, [_c('div', [_vm._v("销售价：¥" + _vm._s(prod.salePrice))]), _vm._v(" "), _c('div', [_vm._v("x" + _vm._s(prod.productQty))])])])])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "pd-250 bd-bot flex-between flex-center fs-28"
    }, [_c('div', [_c('span', {
      staticClass: "color-999"
    }, [_vm._v("顾客：")]), _vm._v(" "), _c('span', {
      staticClass: "color-333"
    }, [_vm._v(_vm._s(item.nickname))])]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "color-999"
    }, [_vm._v("合计：")]), _vm._v(" "), _c('span', {
      staticClass: "fs-24 color-red"
    }, [_vm._v("¥")]), _vm._v(" "), _c('span', {
      staticClass: "fs-36 color-red"
    }, [_vm._v(_vm._s(item.receivable))])])]), _vm._v(" "), (item.remark && item.remark != '') ? _c('div', {
      staticClass: "pd-250 bd-bot flex-between flex-center fs-28"
    }, [_c('div', [_c('span', {
      staticClass: "color-999"
    }, [_vm._v("备注：")]), _vm._v(" "), _c('span', {
      staticClass: "color-333"
    }, [_vm._v(_vm._s(item.remark))])])]) : _vm._e(), _vm._v(" "), (item.orderStatus == 2 && _vm.isManager != '1') ? _c('div', {
      staticClass: "btn-group"
    }, [_c('div', {
      staticClass: "btn click active",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.getScrollerPosition();
          _vm.$router.push({
            name: 'sendOrder',
            query: {
              orderId: item.orderId
            }
          })
        }
      }
    }, [_vm._v("发货")])]) : _vm._e(), _vm._v(" "), (item.orderStatus == 3 && _vm.isManager != '1') ? _c('div', {
      staticClass: "btn-group"
    }, [_c('div', {
      staticClass: "btn click active",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deliverOrder(item)
        }
      }
    }, [_vm._v("已送达")])]) : _vm._e()])
  }), 0)])], 1), _vm._v(" "), _c('van-popup', {
    style: ({
      height: '60%'
    }),
    attrs: {
      "position": "bottom",
      "round": ""
    },
    model: {
      value: (_vm.showOrgPicker),
      callback: function($$v) {
        _vm.showOrgPicker = $$v
      },
      expression: "showOrgPicker"
    }
  }, [_c('div', {
    staticClass: "org-picker-popup"
  }, [_c('van-search', {
    attrs: {
      "placeholder": "搜索小区名称",
      "shape": "round"
    },
    model: {
      value: (_vm.orgSearchKey),
      callback: function($$v) {
        _vm.orgSearchKey = $$v
      },
      expression: "orgSearchKey"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "org-picker-list"
  }, [_c('div', {
    staticClass: "org-picker-item click",
    class: {
      active: !_vm.orgInf.orgId
    },
    on: {
      "click": function($event) {
        return _vm.onSelectOrg(null)
      }
    }
  }, [_vm._v("\n                        全部小区\n                    ")]), _vm._v(" "), _vm._l((_vm.filteredOrgList), function(item) {
    return _c('div', {
      key: item.orgId,
      staticClass: "org-picker-item click",
      class: {
        active: _vm.orgInf.orgId === item.orgId
      },
      on: {
        "click": function($event) {
          return _vm.onSelectOrg(item)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(item.orgName) + "\n                    ")])
  }), _vm._v(" "), (_vm.orgSearchKey && _vm.filteredOrgList.length === 0) ? _c('div', {
    staticClass: "org-picker-empty"
  }, [_vm._v("\n                        暂无匹配小区\n                    ")]) : _vm._e()], 2)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a9f3942","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/order/orderList.vue
// module id = MhmE
// module chunks = 51